<form [formGroup]="voucherEntryForm" (ngSubmit)="savevoucherEntry(inProgress)" class="form-row">
  <div class=" modal-header">
    <h5 class="modal-title d-flex align-items-center">
      <i class="ri-pantone-line me-1 font-20 text-primary"></i>{{voucherEntryForm?.value.id?'Update':'Add'}} Voucher
      Entry
    </h5>
    <button type="button" class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close"
      (click)="activeModal.close('Close')"></button>
  </div>
  <div class="modal-body" formArrayName="voucherEntries">
    <div class="row g-3  mb-3 voucher-entry-row" *ngFor="let voucherEntry of voucherEntries.controls; let i=index"
      [formGroupName]="i">
      <div class="col-md-4">
        <label for="byAccount" class="form-label">Entry Type<b class="text-secondary">*</b></label>
        <div class="d-flex">
          <div class="form-check radio-btn">
            <input class="form-check-input" type="radio" name="entryType{{i}}" id="by-account-{{i}}" [value]="true"
              (change)="selectEntryType(i, 'byAccount')" [checked]="voucherEntry.get('byAccount')?.value">
            <label class="form-check-label" for="by-account-{{i}}">By Account</label>
          </div>
          <div class="form-check radio-btn ms-3">
            <input class="form-check-input" type="radio" name="entryType{{i}}" id="to-account-{{i}}" [value]="true"
              (change)="selectEntryType(i, 'credit')" [checked]="voucherEntry.get('credit')?.value">
            <label class="form-check-label" for="to-account-{{i}}">To Account</label>
          </div>
        </div>
      </div>
      <div class="col-md-8">
        <label for="type" class="form-label">Account <b class="text-secondary">*</b></label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-health'></i></span>
          <ng-select class="form-control rcx-ng-select" formControlName="accountId" placeholder="Select Account type"
            [ngClass]="{'is-invalid': (submitted && voucherEntry.get('accountId')?.errors)}" [clearable]="false">
            <ng-option *ngFor="let account of accounts;" [value]="account.id"
              [disabled]="isAccountSelected(account.id)  && voucherEntry.get('accountId')?.value">
              {{account.name}}
            </ng-option>
          </ng-select>
          <div class="invalid-feedback" *ngIf="(submitted && voucherEntry.get('accountId')?.errors)">
            <span *ngIf="voucherEntry.get('accountId')?.errors.required">Please select an account type.</span>
            <span *ngIf="voucherEntry.get('accountId')?.errors.pattern">Only letters are allowed.</span>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <label for="particular" class="form-label">Particular<b class="text-secondary">*</b></label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-captions'></i></span>
          <input type="text" class="form-control ps-1" id="particular" placeholder="Enter particular"
            [ngClass]="{'is-invalid': (submitted && voucherEntry.get('particular')?.errors)}"
            formControlName="particular" autocomplete="off" />
          <div class="invalid-feedback" *ngIf="(submitted && voucherEntry.get('particular')?.errors)">
            <span *ngIf="voucherEntry.get('particular')?.errors.required">Please provide a valid particular.</span>
            <span *ngIf="voucherEntry.get('particular')?.errors.pattern">Only numbers are allowed.</span>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <label for="amount" class="form-label">Amount <b class="text-secondary">*</b></label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0"><i class='ri-currency-line'></i></span>
          <input type="number" class="form-control ps-1" id="amount" placeholder="Enter amount"
            [ngClass]="{'is-invalid': (submitted && voucherEntry.get('amount')?.errors)}" formControlName="amount"
            autocomplete="off" />
          <div class="invalid-feedback" *ngIf="(submitted && voucherEntry.get('amount')?.errors)">
            <span *ngIf="voucherEntry.get('amount')?.errors.required">Please enter an amount.</span>
            <span *ngIf="voucherEntry.get('amount')?.errors.pattern">Only numbers are allowed.</span>
          </div>
        </div>
      </div>
      <div class="col-md-auto mt-5 ms-auto me-0">
        <button type="button" title="add voucher entry" class="btn btn-secondary btn-sm me-2"
        [disabled]="!voucherEntries.at(i)?.valid || i !== voucherEntries.length - 1" (click)="addVoucherEntry()">          <i class='bx bx-plus'></i> Add
        </button>       
        <button *ngIf="voucherEntries.length > 1" type="button" title="Delete voucher entry"
          (click)="deleteVoucherEntry(i)" class="btn btn-danger btn-sm">
          <i class="bx bx-trash"></i> Delete
        </button>
      </div>
      <div class="col-12" *ngIf="i < voucherEntries.length - 1">
        <div style="border-top: 1px dashed #ced4da; margin: 1rem 0;"></div>
      </div>
    </div>
  </div>
  <div class="modal-footer border-0">
    <button type="button" class="btn btn-light" (click)="activeModal.close('Close')"><i
        class="bx bx-x"></i>Close</button>
    <button type="submit" class="btn btn-secondary" #inProgress [ngClass]="{'no-event':inProgress?.value=='true'}">
      <ng-container *ngIf="inProgress?.value=='true'">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        {{voucherEntryForm.value.id?'Updating...':'Saving...'}}
      </ng-container>
      <ng-container *ngIf="inProgress?.value!='true'">
        <i class="bx bx-save"></i>{{voucherEntryForm.value.id?'Save Changes':'Save'}}
      </ng-container>
    </button>
  </div>
</form>